@if (!showConfirmation) {
<div class="deletable-item-options d-flex">
  <ng-content></ng-content>
  @if (deleteLink) {
  <a [routerLink]="deleteLink" class="red-option">
    <span class="bi bi-x d-inline d-sm-none" aria-hidden="true"></span>
    <span class="d-none d-sm-block">remove</span>
  </a>
  } @if (!deleteLink) {
  <a (click)="showConfirmation = true" class="red-option">
    <span class="bi bi-x d-inline d-sm-none" aria-hidden="true"></span>
    <span class="d-none d-sm-block">remove</span>
  </a>
  }
</div>
} @if (showConfirmation) {
<div class="deletable-item-options d-flex flex-column align-items-center">
  <div>Are you sure?</div>
  <div class="d-flex">
    <a (click)="confirmDelete()" class="blue-option">
      <span class="bi bi-check2 d-inline d-sm-none" aria-hidden="true"></span>
      <span class="d-none d-sm-block">yes</span>
    </a>
    |
    <a (click)="showConfirmation = false" class="red-option">
      <span class="bi bi-x d-inline d-sm-none" aria-hidden="true"></span>
      <span class="d-none d-sm-block">no</span>
    </a>
  </div>
</div>
}
